import {
  Box,
  Grid2 as Grid,
  InputLabel,
  styled,
  Typography,
} from "@mui/material";
import { FILE_PATH_URI } from "../../utils/helper";
import React, { Fragment, useEffect, useState } from "react";
import { red } from "@mui/material/colors";
import { uid } from "uid";

const FileInput1 = styled("input")(() => ({ display: "none" }));
const Image = styled("img")(() => ({}));

function FileInput({
  id,
  files,
  errors,
  label,
  errText,
  placeholderText,
  name,
  defaultValue = [],
  ...rest
}) {
  id = id || uid(6);

  const [images, setImages] = useState(defaultValue);
  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      if (defaultValue[0] instanceof File) {
        const views = defaultValue.map((file) => URL.createObjectURL(file));
        setImages(views);

        return () => {
          views.forEach((url) => URL.revokeObjectURL(url));
        };
      } else {
        setImages(defaultValue);
      }
    }
  }, [defaultValue]);
  const handleImagePreview = (e) => {
    files.current[name] = Array.from(e.target.files);
    const views = files.current[name]?.map((img) => URL.createObjectURL(img));
    setImages(views);
  };

  return (
    <Fragment>
      <Box>
        <Typography variant="specialistSignup">{label}</Typography>
        <InputLabel htmlFor={id} variant="fileUploadLabel">
          <Typography
            component="span"
            fontSize={18}
            fontWeight="600"
            color="black"
          >
            {placeholderText}
          </Typography>
          <FileInput1
            id={id}
            type="file"
            accept="image/*"
            onChange={handleImagePreview}
            {...rest}
          />
        </InputLabel>
        {errors?.[name] && (
          <Typography mt={1} color={red["500"]}>
            {errText}
          </Typography>
        )}
      </Box>
      <Grid container spacing={2}>
        {Array.isArray(images) ? (
          images?.map((image, i) => (
            <Grid key={i} size={{ xs: 12, md: 4, lg: 3, xxl: 12 / 5 }}>
              <Image
                sx={{
                  width: "100%",
                  height: "100%",
                  maxWidth: "350px",
                  aspectRatio: "1/1",
                  overflow: "hidden",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
                src={image?.path ? FILE_PATH_URI + image?.path : image}
              />
            </Grid>
          ))
        ) : (
          <Grid size={{ xs: 12, md: 4, lg: 3, xxl: 12 / 5 }}>
            <Image
              sx={{
                width: "100%",
                height: "100%",
                maxWidth: "350px",
                aspectRatio: "1/1",
                overflow: "hidden",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              src={FILE_PATH_URI + images}
            />
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
}

export default FileInput;
